import {EmployeeInfo} from "../../../model/schedule.model";
import {JSonSerializer} from "../../../model/JSonSerializer";

import {TwilioUser} from "../../../model/TwilioUser";
import * as moment from "moment";
import {Utils} from "../../../model/Utils";


export class EmployeeGroup{

  id: number = -1 *moment().unix();
  name: string;
  visible = true;
  ownerId: string;
  ownerFullName: string;
  note: string;

}

export class EmployeeGroupUser{

  groupId = 0;
  employeeId = '';
  active = true;
  fullName:          string;
  canAddEmployee = false;
  canRemoveEmployee = false;

}

export class EmployeeGroupAggregation{

  group = new EmployeeGroup();
  employees = new Array<EmployeeInfo>();
  twilioUsers = new Array<TwilioUser>();


  accesses = new Array<EmployeeGroupUser>();



  _createFromArray(propertyName: string, data: any) {
    if ('employees' === propertyName) {
      const serializer = new JSonSerializer();
      for (const bean of <EmployeeInfo[]> data) {
        const tmp = new EmployeeInfo();
        serializer.deserialize(bean, tmp);
        this.employees.push(tmp);
      }
    }
    if ('twilioUsers' === propertyName) {
      const serializer = new JSonSerializer();
      for (const bean of <TwilioUser[]> data) {
        const tmp = new TwilioUser();
        serializer.deserialize(bean, tmp);
        this.twilioUsers.push(tmp);
      }
    }
    if ('accesses' === propertyName) {
      const serializer = new JSonSerializer();
      for (const bean of <EmployeeGroupUser[]> data) {
        const tmp = new EmployeeGroupUser();
        serializer.deserialize(bean, tmp);
        this.accesses.push(tmp);
      }
    }
    //
    // if ('users' === propertyName) {
    //   const serializer = new JSonSerializer();
    //   for (const bean of <PlanningUser[]> data) {
    //     const tmp = new PlanningUser();
    //     serializer.deserialize(bean, tmp);
    //     this.users.push(tmp);
    //   }
    // }
  }


  public hasAccessToThisServiceId(employeeId: string, serviceId: string):boolean{
    if (this.twilioUsers && this.twilioUsers.length>0){
      for (const tw of this.twilioUsers){

        if ((serviceId === tw.sid) && (employeeId === tw.employeeId)){
          return true;
        }
      }
    }
    return false;
  }

  hasAccess(employeeId: string):boolean{

    if (!Utils.isNullOrUndefined(employeeId)){
      /*
      if (this.group.ownerId === employeeId){
        return true;
      }

       */
      if ( this.accesses!=null && this.accesses.length > 0 ) {
        for (const nwu of this.accesses){
          if (nwu.employeeId === employeeId){
            return true;
          }
        }
      }
    }
    return false;
  }

  canAdd(employeeId: string):boolean{
    if (!Utils.isNullOrUndefined(employeeId)){
      if ( this.accesses!=null && this.accesses.length > 0 ) {
        for (const nwu of this.accesses){
          if (nwu.employeeId === employeeId){
            return nwu.canAddEmployee;
          }
        }
      }
    }
    return false;
  }

  canRemove(employeeId: string):boolean{
    if (!Utils.isNullOrUndefined(employeeId)){
      if ( this.accesses!=null && this.accesses.length > 0 ) {
        for (const nwu of this.accesses){
          if (nwu.employeeId === employeeId){
            return nwu.canRemoveEmployee;
          }
        }
      }
    }
    return false;
  }

  hasOwnership(employeeId: string):boolean{
    if (Utils.isNullOrUndefined(this.group.ownerId)){
      return true;
    }

    if (!Utils.isNullOrUndefined(this.group.ownerId)) {
      if (this.group.ownerId === employeeId) {
        return true;
      }
    }
    return false;
  }


}
